import { uniqueId } from 'lodash';
import type { Resolvers } from '../../../../../generated';

export const resolvers: Resolvers = {
  MetadataFilter: {
    id: (filter) => filter.id || uniqueId('filter-'),
  },
};
